/* ============================================================
   Product Image Zoom — Fancybox 5
   Arquivo isolado: inicialização, clique no ícone e pinch-to-zoom
   ============================================================ */
(function () {
  "use strict";

  function initProductZoom() {
    if (typeof Fancybox === "undefined") return;

    // Inicializa o lightbox para imagens do produto APENAS no mobile/tablet
    // (telas até 1024px). Em telas maiores (Desktop), o Hover Zoom (Lupa) 
    // assume o controle total e o clique não abre o popup.
    if (window.innerWidth <= 1024) {
      Fancybox.bind('[data-fancybox="images"]', {
        loop: true,
        clickContent: "close", // Clicar na imagem fecha o lightbox
        thumbs: {
          autoStart: true,
        },
        // Panzoom: controla pinch-to-zoom e pan nativo do Fancybox 5
        Panzoom: {
          maxScale: 4,
          touch: true,
          zoom: true,
        },
      });
    }
  }

  // Zoom icon: event delegation para garantir que funciona mesmo se o elemento
  // for adicionado ao DOM depois do carregamento inicial (ex: Slick carousel)
  function initZoomIcon() {
    document.addEventListener("click", function (e) {
      var icon = e.target.closest(".productView-iconZoom");
      if (!icon) return;

      // Tenta primeiro o slide ativo do carrossel (slick-current)
      var activeAnchor =
        document.querySelector(
          ".productView-image.slick-current [data-fancybox='images']"
        ) || document.querySelector("[data-fancybox='images']");

      if (activeAnchor) activeAnchor.click();
    });
  }

  // Corrige o Hover Zoom (Lupa) no Desktop.
  // O carrossel Slick destrói os eventos do hover zoom ao clonar os slides.
  // Esta função garante que a lupa seja reativada corretamente.
  function initHoverZoomFix() {
    if (window.innerWidth <= 1024) return;
    if (typeof jQuery === "undefined" || typeof jQuery.fn.zoom === "undefined") return;

    function applyZoom() {
      jQuery('.productView-image [data-zoom-image]').each(function () {
        var $this = jQuery(this);
        // Se a imagem de zoom ainda não foi criada neste slide, inicializa:
        if ($this.find('.zoomImg').length === 0) {
          $this.zoom({ url: $this.attr("data-zoom-image"), touch: false });
        }
      });
    }

    // Aplica o zoom com um pequeno delay para garantir que o Slick já montou a tela
    setTimeout(applyZoom, 800);

    // Reaplica o zoom toda vez que o usuário trocar de foto no carrossel
    jQuery(document).on('afterChange', '.productView-nav, .slick-slider', function () {
      applyZoom();
    });
  }

  // Garante que roda após o DOM e o Fancybox estarem disponíveis
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initProductZoom();
      initZoomIcon();
      initHoverZoomFix();
    });
  } else {
    // DOM já pronto (script carregado de forma defer/async ou no final da página)
    initProductZoom();
    initZoomIcon();
    initHoverZoomFix();
  }
})();
